import logo from '../assets/logo.png';
import closeIcon from '../assets/newclose.png';
import icon from '../assets/icon.png';
import arrow1 from '../assets/arrow1.png';
import { Layout, Button, Menu, Flex, Modal, Image, Tooltip, Dropdown, QRCode } from 'antd';
import { useNavigate, Link, useLocation, useParams } from 'react-router-dom';
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import SearchComponent from './Search';
import LoginComponent from './Login';
import unit from '../unit';
import '../App.css';
import Cookies from 'react-cookies';
const { Header } = Layout;

// 新增：路径参数与数字的映射关系
const typeMap = {
  'institution': 1,
  'niusan': 2,
  'fund': 3,
  'nationalteam': 4,
  'foreigncapital': 5
};

// 新增：数字到路径参数的反向映射
const reverseTypeMap = {
  1: 'institution',
  2: 'niusan',
  3: 'fund',
  4: 'nationalteam',
  5: 'foreigncapital'
};

const HeaderComponent = forwardRef((props, ref) => {
  const { type } = useParams();
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(false);
  const [style, setStyle] = useState({
    height: '54px',
    lineHeight: '54px',
    overflow: 'hidden',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
  });
  const navigate = useNavigate();
  const [menuItem, setMenuItem] = useState([
    {
      label: '首页',
      key: '/index',
    },
    {
      label: '知名机构',
      key: '/institution',
    },
    {
      label: '牛散',
      key: '/niusan',
    },
    {
      label: '金牛基金',
      key: '/fund',
    },
    {
      label: '国家队',
      key: '/nationalteam',
    },
    {
      label: '外资',
      key: '/foreigncapital',
    },
  ]);
  const [current, setCurrent] = useState([]);
  const [adData, setAdData] = useState(null);
  const [isAdModalVisible, setIsAdModalVisible] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [followCount, setFollowCount] = useState(0); // 新增：关注数量状态

  const getAdvertising = () => {
    const path = '/pc/gudong/ad';
    unit.httpGet(path, {}, (data) => {
      if (data.show) {
        setAdData(data);
      }
    });
  };

  const getFollowCount = () => {
    if (!userInfo) return;
    
    const path = '/pc/gudong/myFollow';
    unit.httpGet(path, {}, (data) => {
      setFollowCount(data.count);
    });
  };

  useEffect(() => {
    getAdvertising();
    const user_id = window.localStorage.getItem("user_id");
    const nickname = window.localStorage.getItem("nickname");
    const avatar = window.localStorage.getItem("avatar");
    const token = unit.getToken();
    if (token && user_id && nickname && avatar) {
      setUserInfo({ user_id, nickname, avatar });
    }
  }, [showLogin]);

  // 新增：监听用户信息变化，获取关注数量
  useEffect(() => {
    getFollowCount();
  }, [userInfo]);

  useImperativeHandle(ref, () => ({
    onLogin: onLogin,
    handleFloatingBallClick: handleFloatingBallClick
  }));

  const onLogin = () => {
    setShowLogin(true);
  };

  const closeLogin = () => {
    setShowLogin(false);
  };

  const menuClick = ({ key }) => {
    setCurrent([key]);
    navigate(key);
  };

  useEffect(() => {
    const pathname = location.pathname;
    let currentKey = '';

    if (pathname === '/index') {
      currentKey = '/index';
    } else if (pathname.startsWith('/') && type) {
      // 检查type是否在映射中存在
      if (Object.keys(typeMap).includes(type)) {
        currentKey = `/${type}`;
      }
    }

    const isCurrentKeyValid = menuItem.some(item => item.key === currentKey);
    setCurrent(isCurrentKeyValid ? [currentKey] : []);
  }, [location, type]);

  const handleFloatingBallClick = () => {
    if (!userInfo) {
      setShowLogin(true);
    } else {
      if (adData) {
        setIsAdModalVisible(true);
      }
    }
  };

  const handleAdModalClose = () => {
    setIsAdModalVisible(false);
  };

  const handleLogout = () => {
    window.localStorage.removeItem("user_id");
    window.localStorage.removeItem("nickname");
    window.localStorage.removeItem("avatar");
    Cookies.remove('web_qtstr', {path:"/", domain:'cangweizaixian.com'});
    setUserInfo(null);
    window.location.reload();
  };

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <Link to="/myfollow">
          我的关注 <span className="follow-count-badge">({followCount})</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="/feedback">
          意见反馈 
        </Link>
      </Menu.Item>
      <Menu.Item key="3" onClick={handleLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <Header className='header-container' style={style}>
      <Flex justify="space-between" align="center" className="header-flex">
        <div className='left-fixed'>
          <Link to='/index'><img style={{ verticalAlign: 'middle', width: '110px' }} src={logo} /></Link>
        </div>
        <div className='middle-adaptive' style={style}>
          <div className='menu-container'>
            <Menu
              theme='dark'
              onClick={menuClick}
              defaultSelectedKeys={current}
              selectedKeys={current}
              mode="horizontal"
              items={menuItem}
            ></Menu>
          </div>
          <div style={{ display: 'inline-block', marginLeft: '50px', marginTop: '32px' }}>
            <SearchComponent isHeader={true}></SearchComponent>
          </div>
        </div>
        <div className='right-fixed'>
          {userInfo ? (
            <Dropdown
              overlay={menu}
              trigger={['click', 'hover']}
              overlayClassName="user-dropdown-menu"
            >
              <div
                className="user-info"
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              >
                <Tooltip placement="bottom" title={userInfo.nickname}>
                  <img
                    src={userInfo.avatar}
                    alt="用户头像"
                    style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '10px', verticalAlign: 'middle' }}
                  />
                </Tooltip>
                <span
                  style={{
                    verticalAlign: 'middle',
                    display: 'inline-block',
                    maxWidth: '100px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {userInfo.nickname}
                </span>
                <img
                  src={arrow1}
                  alt="下拉箭头"
                  style={{ marginLeft: '10px', cursor: 'pointer' }}
                />
              </div>
            </Dropdown>
          ) : (
            <Button onClick={onLogin} className='login' type="primary" danger>
              登录/注册
            </Button>
          )}
        </div>
        <LoginComponent showLogin={showLogin} closeLogin={closeLogin} />
        <div className='clear'></div>
      </Flex>
      <div className="floating-ball" onClick={handleFloatingBallClick}>
        <img src={icon} alt="广告" />
      </div>
      <Modal
        visible={isAdModalVisible}
        onCancel={handleAdModalClose}
        footer={null}
        centered
        closable={false}
        className="custom-modal"
      >
        <div style={{ position: 'relative' }}>
          <Image src={adData?.image_url} alt="广告" style={{ display: 'block', margin: '0 auto' }} preview={false} />
          <img
            src={closeIcon}
            alt="关闭"
            className="custom-close-button"
            onClick={handleAdModalClose}
          />
          <div className='ad-qrcode'>{adData && adData.qrcode_url ? <QRCode value={adData.qrcode_url} /> : ''}</div>
        </div>
      </Modal>
    </Header>
  );
});

export default HeaderComponent;